import { gql } from "@apollo/client";

export const DELETE_DOCUMENTO_CONTRATO = gql`
    mutation deleteDocumentoContrato(
        $idDocumento: Int!
    ){
        deleteDocumentoContrato( idDocumento: $idDocumento) 
    }
`;